<template>
    <div>
        <template v-if="type == 'sidebar'">
            <button v-on:click.prevent="sidebarLeftSubscribeShowTooltip($event)" class="btn btn-clean sidebar-left__subscribe-help">
                <i class="icon-32 icon-question"></i>
            </button>
            <form :action="url" method="post" @submit.prevent="submit">
                <div class="nav-title sidebar-left__subscribe-title">{{ t.subscribe_new_businesses }}</div>
                <input ref="sidebarInput" name="email" v-model="formData.email" :disabled="loading" class="sidebar-left__subscribe-input form-control" :placeholder="t.new_businesses_on_email" type="email" :title="t.new_businesses_on_email_hint">
                <button type="submit" :disabled="loading" class="btn btn-outline-transparent btn-block sidebar-left__subscribe-btn">{{ t.subscribe }}</button>
                <div id="sidebar-subscribe-recaptcha-container"></div>
            </form>
        </template>
        <template v-else-if="type == 'header'">
            <form :action="url" method="post" @submit.prevent="submit">
                <div class="input-group" ref="headerInput" :title="t.new_businesses_on_email_hint">
                    <input name="email" v-model="formData.email" :disabled="loading" type="text" class="header__subscribe-input-text form-control" :placeholder="t.new_businesses_on_email_short" :aria-label="t.new_businesses_on_email_short"
                        aria-describedby="header-button-subscribe">
                    <div class="input-group-append">
                        <button class="btn btn-outline-transparent header__subscribe-button" type="submit" :disabled="loading" id="header-button-subscribe">{{ t.subscribe }}</button>
                    </div>
                </div>
                <div id="header-subscribe-recaptcha-container"></div>
            </form>
            <button class="header__subscribe-help btn btn-clean" v-on:click.prevent="headerSubscribeShowTooltip($event)" ><i class="icon-32 icon-question"></i></button>
        </template>
        <template v-else-if="type == 'banner'">
            <form name="subscribebannerform" :action="url" method="post" @submit.prevent="submit">
                <input name='verified' v-model="formData.verified" type='hidden' value='N'>
                <div class="form-group">
                    <div class="input-group">
                        <input name="email" v-model="formData.email" type="text" :disabled="loading" class="form-control form-control-padding-lg" :placeholder="t.enter_email">
                        <div class="input-group-append rounded-corners">
                            <button class="btn btn-shadow-primary px-3" type="submit" :disabled="loading">{{ t.subscribe }}</button>
                        </div>
                    </div>
                    <div v-if="formErrors.email" class="form-text text-danger text-left">{{formErrors.email}}</div>
                </div>
                <div id="banner-subscribe-recaptcha-container"></div>
            </form>
            <div class="small text-muted mt-4">
				{{ t.new_businesses_on_email_hint }}
			</div>
        </template>
    </div>
</template>

<script>
const containerIdsMap = {
    sidebar: 'sidebar-subscribe-recaptcha-container',
    header: 'header-subscribe-recaptcha-container',
    banner: 'banner-subscribe-recaptcha-container',
};

export default {
    props: ['t','url','type'],
    data() {
        return {
            loading: false,
            successResult: false,
            formData: {},
            formError: false,
            formErrors: {},
            recaptchaWidgetId: null
        };
    },
	methods: {
		formValidate() {
            this.formErrors = {};
            if (!this.formData['email']) {
                this.formErrors['email'] = this.t.e_email_required;
            }
            for (var field of []) {
                if (!this.formData[field]) {
                    this.formErrors[field] = this.t.e_required;
                }
            }
            this.formError = Object.keys(this.formErrors).length != 0;
            return !this.formError;
        },
        submit() {
            if (this.formValidate()) {
                this.recaptchaRender();
                this.$root.recaptchaExecute(this.recaptchaWidgetId);
            }
        },
        sendData() {
            this.loading = true;
            $.ajax({
                url: this.url,
                data: this.formData,
                type: 'post',
                dataType: 'json',
                success: function (data) {
                    window.location.reload();
                    // if (data.success) {
                    //     this.successResult = true;
                    // } else {
                    //     this.loading = false;
                    //     this.formError = true;
                    //     this.formErrors = data.errors;
                    //     this.$root.recaptchaReset(this.recaptchaWidgetId);
                    // }
                }.bind(this)
            });
        },
        headerSubscribeShowTooltip(e) {
            const elem = this.$refs.headerInput;
            $(elem).tooltip({
                trigger: 'manual',
                placement: 'bottom',
                template: `<div class="tooltip header__subscribe-tooltip" role="tooltip"><div class="tooltip-inner"></div></div>`,
            });
            $(elem).tooltip('toggle');
            const hideTooltip = () => {
                $(elem).tooltip('hide');
                $('body').off('click', hideTooltip);
            };
            $('body').on('click', hideTooltip);
            e.stopImmediatePropagation();
        },
        sidebarLeftSubscribeShowTooltip(e) {
            const elem = this.$refs.sidebarInput;
            $(elem).tooltip({
                trigger: 'manual',
                placement: 'bottom',
                template: `<div class="tooltip sidebar-left__subscribe-tooltip" role="tooltip"><div class="tooltip-inner"></div></div>`,
            });
            $(elem).tooltip('toggle');
            const hideTooltip = () => {
                $(elem).tooltip('hide');
                $('body').off('click', hideTooltip);
            };
            $('body').on('click', hideTooltip);
            e.stopImmediatePropagation();
        },
        recaptchaRender() {
            if (this.recaptchaWidgetId === null) {
                const containerId = containerIdsMap[this.type];
                this.recaptchaWidgetId = this.$root.recaptchaRender(containerId, (token) => {
                    this.formData['g-recaptcha-response'] = token;
                    this.sendData();
                });
            }
        },
	},
}
</script>

<style>
    
</style>